module.exports = __webpack_public_path__ + "static/media/file-upload.0feb453e.svg";